import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Link } from 'react-router-dom';
import Layout from '../layout';

import styles from '../styles/pages/coming-soon.scss';
import APP_ROUTES from '../../constants/app-routes';
import SignupPromotion from '../shared/signup-promotion';

class ComingSoon extends Component {
    constructor(props) {
        super(props);

        document.title = this.props.intl.formatMessage({ id: 'title', defaultMessage: 'Online Store for Cuba' });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'title', defaultMessage: 'Online Store for Cuba' });
        }
    }

    render() {
        return (
            <Layout>
                <div className={styles.comingContainer}>
                    <h1 className={styles.mainText}>
                        <FormattedMessage id="coming-soon-text" defaultMessage="These products will be available soon" />
                    </h1>
                    <h2 className={styles.secondaryText}>
                        <FormattedMessage
                            id="coming-soon-desc"
                            defaultMessage="We are adding new features to our platform. Soon these products will be available. Please, be patient and explore our"
                        />
                        <Link to={APP_ROUTES.mercadoUnicoProducts}>
                            <FormattedMessage id="mercado-unico" defaultMessage="Mercado Unico" />
                            .
                        </Link>
                    </h2>
                    <Link to={APP_ROUTES.mercadoUnicoProducts} className={styles.buttonLink}>
                        <FormattedMessage id="coming-soon-button" defaultMessage="See Mercado Unico Products" />
                    </Link>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(ComingSoon);



/** WEBPACK FOOTER **
 ** ./src/components/pages/coming-soon.jsx
 **/